var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVistaprintProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6ecff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#2ba8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006196"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.03644 51.18988 61.56799 53.78125 56.16925 63.2182 61.56799 72.65521 66.96667 63.2182 73.83386 51.18988 63.03644 51.18988"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.30206 51.16827 56.16925 63.19666 61.56799 53.75964 60.09949 51.18988 60.09949 51.16827 49.30206 51.16827"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.45929,36.80927l-5.6098-3.23877-18.48676,10.6734,6.79382,3.92236c.36646.21155.81793.21155,1.18433,0l16.11841-9.3056c.78961-.45581.78961-1.59552,0-2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.03857,38.86072l5.1319,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18439,0l-16.11823,9.30585c-.78955.45587-.78955,1.59558,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.16614,43.45917v18.68835c0,.41125.21942.7912.5755.99683l16.18451,9.34412c.76733.44305,1.7265-.11078,1.7265-.99683v-18.68817c0-.41119-.21936-.7912-.5755-.99683l-6.8717-3.96747v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95648c-.76733-.44299-1.72656.11078-1.72656.99683Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistaprintProductsScraper);
export default __webpack_public_path__ + "static/media/vistaprint-products-scraper.6b12196f96113966f64e753d0830c9a7.svg";
export { ForwardRef as ReactComponent };